import { useState } from 'react'

import { AddButton } from '#app/routes/mocra+/_form+/components/add-button.tsx'

import { RepositoryOverlay } from '#app/routes/mocra+/_form+/components/repositories/overlay.tsx'
import {
	createRepositoryDraft,
	type RepositoryDraft,
} from '#app/routes/mocra+/_form+/components/repositories/types.ts'

type Props = {
	readonly onSubmit: (draft: RepositoryDraft) => void
	readonly defaultValue?: RepositoryDraft
	readonly triggerLabel?: string
	readonly disabled?: boolean
	readonly className?: string
}

export function RepositoryAdd({
	onSubmit,
	defaultValue,
	triggerLabel,
	disabled,
	className,
}: Props) {
	const [open, setOpen] = useState(false)

	const handleSubmit = (draft: RepositoryDraft) => {
		onSubmit(draft)
		setOpen(false)
	}

	return (
		<>
			<AddButton
				onClick={() => setOpen(true)}
				disabled={disabled}
				className={className}
			>
				{triggerLabel ?? 'Add repository'}
			</AddButton>
			<RepositoryOverlay
				mode="add"
				open={open}
				onOpenChange={setOpen}
				onSubmit={handleSubmit}
				initialValue={defaultValue ?? createRepositoryDraft()}
				onClosed={() => setOpen(false)}
			/>
		</>
	)
}
